import { render, staticRenderFns } from "./GestioneModuli.vue?vue&type=template&id=484f2d94&scoped=true&"
import script from "./GestioneModuli.vue?vue&type=script&lang=js&"
export * from "./GestioneModuli.vue?vue&type=script&lang=js&"
import style0 from "./GestioneModuli.vue?vue&type=style&index=0&id=484f2d94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484f2d94",
  null
  
)

export default component.exports